export default __webpack_public_path__ + "static/media/previous.4ccf2fd0.svg";